export const PRIMARY_COLOR = "#DD6FD1";
export const PRIMARY_COLOR_DARKER = "#c463ba";
export const PRIMARY_COLOR_LIGHTER = "#f8d6f5";
export const PRIMARY_COLOR_SUPER_LIGHTER = "#ffeeff";

document.documentElement.style.setProperty("--primary-color", PRIMARY_COLOR);
document.documentElement.style.setProperty("--primary-color-darker", PRIMARY_COLOR_DARKER);
document.documentElement.style.setProperty("--primary-color-lighter", PRIMARY_COLOR_LIGHTER);
document.documentElement.style.setProperty("--primary-color-super-lighter", PRIMARY_COLOR_SUPER_LIGHTER);